import { PromptView } from '@lemoncloud/ssocio-chatbots-api';
import { QueryClient } from '@tanstack/react-query';

import { updateAllListCaches } from '@codes/shared';

export const updateCacheWithNewPrompt = (queryClient: QueryClient, resource: string, newPrompt: PromptView) => {
    updateAllListCaches({ resource, queryClient }, (oldData: any) => {
        if (!oldData?.data) {
            return oldData;
        }

        return {
            ...oldData,
            data: [newPrompt, ...oldData.data],
            list: [newPrompt, ...oldData.list],
            total: (oldData.total || 0) + 1,
        };
    });
};

export const updateCacheWithUpdated = (
    queryClient: QueryClient,
    resource: string,
    updatedPrompt: PromptView,
    promptId: string
) => {
    updateAllListCaches({ resource, queryClient, shouldInvalidate: false }, (oldData: any) => {
        if (!oldData?.data) {
            return oldData;
        }

        const updatePrompt = (origin: PromptView) => (origin.id === promptId ? updatedPrompt : origin);
        return {
            ...oldData,
            data: oldData.data.map(updatePrompt),
            list: oldData.list.map(updatePrompt),
        };
    });
};

export const updateCacheWithDeleted = (queryClient: QueryClient, resource: string, promptId: string) => {
    updateAllListCaches({ resource, queryClient, shouldInvalidate: false }, (oldData: any) => {
        if (!oldData?.data) {
            return oldData;
        }

        return {
            ...oldData,
            data: oldData.data.filter((prompt: PromptView) => prompt.id !== promptId),
            list: oldData.list.filter((prompt: PromptView) => prompt.id !== promptId),
            total: Math.max(0, (oldData.total || 0) - 1),
        };
    });
};

export const updateRevisionCacheWithDeleted = (
    queryClient: QueryClient,
    promptId: string,
    deletedRevisionId: string
) => {
    updateAllListCaches({ resource: 'revision', queryClient, shouldInvalidate: false }, (oldData: any) => {
        if (!oldData?.data) {
            return oldData;
        }

        return {
            ...oldData,
            data: oldData.data.filter((revision: PromptView) => revision.id !== deletedRevisionId),
            list: oldData.list.filter((revision: PromptView) => revision.id !== deletedRevisionId),
            total: Math.max(0, (oldData.total || 0) - 1),
        };
    });
};

export const updateRevisionCacheWithNew = (queryClient: QueryClient, promptId: string, newRevision: PromptView) => {
    updateAllListCaches({ resource: 'revision', queryClient, shouldInvalidate: false }, (oldData: any) => {
        if (!oldData?.data) {
            return oldData;
        }

        return {
            ...oldData,
            data: [newRevision, ...oldData.data],
            list: [newRevision, ...oldData.list],
            total: (oldData.total || 0) + 1,
        };
    });
};
